require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-cloudthing-devops-company-of-the-year-computing-devops-excellence-awards.json") })
        }
      }, "path---blog-cloudthing-devops-company-of-the-year-computing-devops-excellence-awards");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-cloudthing-devops-company-of-the-year-computing-devops-excellence-awards!./.cache/json/blog-cloudthing-devops-company-of-the-year-computing-devops-excellence-awards.json
// module id = 813
// module chunks = 231608221292675